import LoadingAnimation1 from 'assets/loadingAnimation/loading-animation-1.lottie';
import LoadingAnimation2 from 'assets/loadingAnimation/loading-animation-2.lottie';
import LoadingAnimation3 from 'assets/loadingAnimation/loading-animation-3.lottie';
import LoadingAnimation4 from 'assets/loadingAnimation/loading-animation-4.lottie';

// Reference lottie files directly from the public directory
export const loadingAnimationPaths = {
  circle1: LoadingAnimation1,
  looping: LoadingAnimation2,
  circle2: LoadingAnimation3,
  line: LoadingAnimation4
} as const;

export type LoadingAnimationName = keyof typeof loadingAnimationPaths;

export const loadingAnimationNames = Object.keys(loadingAnimationPaths) as LoadingAnimationName[];
